// export const myMutation = (state) => {
    //Son sincronas
    //Reciben el state
// }

export const defaultMutation = (/*state*/) => {
    
}